<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent(); scrollContentToTop()"
  [title]="titlePage"
  [start]="startStage"
  [end]="endStage"
></app-ion-common-header>

<ion-content
  *ngIf="!showRetry && !loading"
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <div
    #content
    class="content-list content-scroll"
    [ngClass]="{'content-list--with-button' : selectedItem}"
  >
    <div class="w-title">
      <app-ion-common-label
        [id]="idLabelProfession"
        class="document-type-label1"
        labelStyle="display-rg"
        labelDescription="Qual é sua profissão?"
      >
      </app-ion-common-label>
    </div>
    <div
      class="conent-center conent-center--mrt-lg"
      [attr.aria-hidden]="ariaHidden"
    >
      <div class="my-search">
        <app-ion-common-search
          [id]=" idInputSearchProfession"
          [textSearch]="textSearch"
          [ariaLabel]="'Busque por profissões'"
          [placeholder]="'Busque por profissões'"
          [list]="professionList"
          [fieldSearch]="fieldSearch"
          [textError]="'Profissão não encontrada'"
          (sendTextSearch)="textSearch = $event;"
        >
        </app-ion-common-search>
      </div>

      <app-ion-common-radio
        class="document-type-options"
        [id]="idRadioProfession"
        [itens]="professionList"
        [disabled]="!this.edit"
        [selectedValue]="selectedItem"
        [textSearch]="textSearch"
        [fieldSearch]="fieldSearch"
        [filterIncludes]="true"
        (changeRadio)="selectedItem = $event; changeValue()"
        (valueNameRadio)="selectedName=$event;"
      >
      </app-ion-common-radio>
    </div>
  </div>

  <app-ion-common-button
    [id]=" idButtonProfession"
    class="hidden"
    [ngClass]="{'hidden': selectedItem?.length === 0}"
    [attr.aria-hidden]="selectedItem?.length === 0"
    label="Continuar"
    (clickButton)="clickNext();"
  ></app-ion-common-button>
</ion-content>

<ion-content *ngIf="showRetry">
  <app-ion-common-retry
    [headerId]="headerId"
    (sendEventRetry)="getProfessionList()"
  >
  </app-ion-common-retry>
</ion-content>
